import React from 'react';
import { Badge, UncontrolledTooltip } from 'reactstrap';

/**
 * Componente para mostrar el Coeficiente de Variación con color según el nivel
 * 
 * @param {number} cv - Coeficiente de variación (%)
 * @param {Object} alerta - Alerta de variabilidad (opcional)
 */
const CoeficienteVariacionBadge = ({ cv, alerta }) => {
  if (cv === null || cv === undefined) return null;

  const tooltipId = `cv-${Math.random().toString(36).substr(2, 9)}`;

  // Determinar color según el CV
  let color = 'success';
  let nivel = 'Baja';
  let icon = 'ri-checkbox-circle-line';

  if (cv >= 100) {
    color = 'danger';
    nivel = 'Muy Alta';
    icon = 'ri-close-circle-line';
  } else if (cv >= 50) {
    color = 'warning';
    nivel = 'Moderada';
    icon = 'ri-error-warning-line';
  }

  // Si hay alerta, usar su color
  if (alerta && alerta.color) {
    const colorMap = {
      'verde': 'success',
      'amarillo': 'warning',
      'rojo': 'danger'
    };
    color = colorMap[alerta.color] || color;
  }

  return (
    <>
      <Badge 
        color={color} 
        className="fs-8 px-2 py-1 cursor-pointer"
        id={tooltipId}
      >
        <i className={`${icon} me-1`}></i>
        CV: {cv.toFixed(1)}%
      </Badge>
      
      <UncontrolledTooltip placement="top" target={tooltipId}>
        <div className="text-start">
          <strong>Coeficiente de Variación</strong>
          <hr className="my-1" />
          <div>
            <strong>{cv.toFixed(2)}%</strong> - Variabilidad {nivel}
          </div>
          <hr className="my-1" />
          <small className="text-muted">
            <div>✅ {'<'} 50%: Consistente</div>
            <div>⚠️ 50-100%: Variable</div>
            <div>❌ {'>'} 100%: Muy variable</div>
          </small>
          <hr className="my-1" />
          <small className="text-muted">
            <i className="ri-information-line"></i> CV = (σ/μ) × 100
          </small>
        </div>
      </UncontrolledTooltip>
    </>
  );
};

export default CoeficienteVariacionBadge;
